import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Check, X, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setErrorMsg("Lien invalide."); return; }
    api.post(`/auth/verify-email?token=${token}`)
      .then((r) => {
        setStatus("success");
        if (r.data.token && r.data.user) {
          loginWithToken(r.data.token, r.data.user);
        }
      })
      .catch((err) => {
        setStatus("error");
        setErrorMsg(err.response?.data?.detail || "Erreur de vérification");
      });
  }, [token]);

  if (status === "loading") {
    return (
      <div className="max-w-md mx-auto px-6 py-20 text-center" data-testid="verify-loading">
        <Loader2 size={40} className="mx-auto text-terracotta animate-spin mb-6" />
        <h1 className="font-serif-display text-3xl mb-2">Vérification en cours...</h1>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="max-w-md mx-auto px-6 py-20 text-center" data-testid="verify-error">
        <div className="w-20 h-20 mx-auto rounded-full bg-red-100 flex items-center justify-center mb-6">
          <X size={36} className="text-red-500" strokeWidth={2.5} />
        </div>
        <h1 className="font-serif-display text-3xl mb-4">Vérification échouée</h1>
        <p className="text-[#6B655C] mb-6">{errorMsg}</p>
        <Link to="/login" className="text-terracotta hover:underline">Retour à la connexion</Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-6 py-20 text-center" data-testid="verify-success">
      <div className="w-20 h-20 mx-auto rounded-full bg-patchwork flex items-center justify-center mb-6">
        <Check size={36} className="text-white" strokeWidth={2.5} />
      </div>
      <p className="font-accent text-3xl text-terracotta -rotate-2 mb-2">Bienvenue chez Labounite !</p>
      <h1 className="font-serif-display text-3xl mb-4">Compte activé</h1>
      <p className="text-[#6B655C] mb-8">Votre adresse e-mail est confirmée. Vous pouvez maintenant profiter de la boutique.</p>
      <button onClick={() => navigate("/shop")} className="btn-primary">Découvrir la boutique</button>
    </div>
  );
}
